// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// hooks
import { useIfr } from '../../../../../hooks/useIfr';

// context
import { ContextIfr } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// pages
import { IfrAlert } from '../IfrAlert/IfrAlert';

// ui
import { TableSheet } from '../../../../ui/TableSheet/TableSheet';

export const Categories = () => {
	// hooks
	const { handleClickCell } = useIfr();
	const { t } = useTranslation();

	// context
	const { ifr, ifrTables } = useContext(ContextIfr);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<Grid container spacing={2}>
						{!ifr?.ifrPlan && ifr?.status === 'DRAFT' && (
							<Grid item xs={12}>
								<IfrAlert type="IFR_PLAN_NON_EXISTENT" />
							</Grid>
						)}
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.openingBalances?.columns || []}
								isExpandable={false}
								label={t('openingCashBalances')}
								palette={ifrTables?.openingBalances?.palette}
								rows={ifrTables?.openingBalances?.rows || []}
							/>
						</Grid>
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.cashIn?.columns || []}
								defaultExpanded={true}
								label={t('tableSheets.cashIn.title')}
								onClickCell={handleClickCell}
								palette={ifrTables?.cashIn?.palette}
								rows={ifrTables?.cashIn?.rows || []}
							/>
						</Grid>
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.cashOutCategories?.columns || []}
								defaultExpanded={true}
								label={t('tableSheets.cashOutCategories.title')}
								onClickCell={handleClickCell}
								palette={ifrTables?.cashOutCategories?.palette}
								rows={ifrTables?.cashOutCategories?.rows || []}
							/>
						</Grid>
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.reimbursementCategories?.columns || []}
								isExpandable={false}
								label={t('tableSheets.reimbursementCategories.title')}
								palette={ifrTables?.reimbursementCategories?.palette}
								rows={ifrTables?.reimbursementCategories?.rows || []}
							/>
						</Grid>
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.closingBalances?.columns || []}
								isExpandable={false}
								label={t('closingCashBalances')}
								palette={ifrTables?.closingBalances?.palette}
								rows={ifrTables?.closingBalances?.rows || []}
							/>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</Grid>
	);
};
